export const appointStatusColors = {
  new: '', // Новая
  rejected: '#33ff00', // Удалена
  approved: '#33ff00', // Подтверждена
  came: '#33ff00', // Явился
  cancel: '#b94a48', // Отказался
  patient_doesnt_come: '#b94a48', // Не явился
  invited: '#33FF00', // Приглашен
  done: '#bdbdbd', // Приём окончен

  // 1: '', // Новая
  // 2: '#33ff00', // Удалена
  // 3: '#4dd12c', // Подтверждена
  // 4: '#33ff00', // Явился
  // 5: '#b94a48', // Отказался
  // 6: '#b94a48', // Не явился
  // 7: '#33FF00', // Приглашен
  // 8: '#bdbdbd', // Приём окончен
};

export const baseFilters = [
  {
    id: 1,
    name: 'По датам',
    sysName: 'date',
    filterName: 'Выберите специалистов',
    icon: 'calendar',
  },
  {
    id: 2,
    name: 'По специалистам',
    sysName: 'spec',
    filterName: 'Выберите специалистов',
    icon: 'account',
  },
  {
    id: 3,
    name: 'По кабинетам',
    sysName: 'cabinet',
    filterName: 'Выберите кабинеты',
    icon: 'cabinet',
  },
];

export const selectedModalTabContent = [
  { id: 1, title: 'Специалист', value: '' },
  { id: 2, title: 'Начало', value: '' },
  { id: 3, title: 'Окончание', value: '' },
  { id: 4, title: 'Длительность', value: '' },
  { id: 5, title: 'Кабинет', value: '' },
];

export const modalTabsList = [
  { id: 1, name: 'Запись', description: 'Добавление записи' },
  { id: 2, name: 'Операция', description: 'Добавление операции' },
  { id: 3, name: 'Задача', description: 'Добавление задачи' },
];

export const sideMenuRus = {
  patients: 'Пациенты',
  tasks: 'Задачи',
};

export const sideMenuList = {
  patients: {
    items: [
      { title: 'Список пациентов', link: '/patient/' },
      { title: 'Дни рождения', link: '/patient/birthday/' },
      {
        title: 'Мобильное приложение',
        link: '/patient/report/mappverifyrequest/',
      },
    ],
    isOpen: false,
    link: 'patients'
  },

  tasks: {
    items: [
      { title: 'Задачи', link: '/tasks/tasks' },
      { title: 'Группы задач', link: '/tasks/groups' },
    ],
    isOpen: false,
    link: 'tasks'
  },

};

export const modalCheckboxes = {
  notRenderEmpty: 'не выводить пустые',
  renderComment: 'выводить коммент',
  renderTasks: 'выводить задачи',
};

export const messageWords = ['сообщение', 'сообщения', 'сообщений'];

export const directions = [
  {
    id: 3030,
    name: '11',
    price: '1200',
    is_active: true,
    deleted: false,
    code: '00',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3022,
    name: 'Тестовая 2',
    price: '400',
    is_active: true,
    deleted: false,
    code: '002',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [
      {
        id: 17,
        resource_service: 3022,
        warehouse_item: 17,
        quantity: 1,
        price_in_service: null,
        resource_service_view: '002 Тестовая 2',
        warehouse_item_view: 'Еще материал 2 шт',
        is_vaccine: false,
        for_sale: false,
        sale_price: '500',
        warehouse_item_id: 17,
        name: 'Еще материал 2',
        cost_value: 237,
        batch: null,
        batchs: [],
      },
    ],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3031,
    name: 'Тестовая',
    price: '3000',
    is_active: true,
    deleted: false,
    code: '004',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3024,
    name: 'Комплекс1',
    price: '100',
    is_active: true,
    deleted: false,
    code: '005',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [
      {
        id: 3022,
        name: 'Тестовая 2',
        price: '400',
        is_active: true,
        deleted: false,
        code: '002',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 17,
            resource_service: 3022,
            warehouse_item: 17,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '002 Тестовая 2',
            warehouse_item_view: 'Еще материал 2 шт',
            is_vaccine: false,
            for_sale: false,
            sale_price: '500',
            warehouse_item_id: 17,
            name: 'Еще материал 2',
            cost_value: 237,
            batch: null,
            batchs: [],
          },
        ],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3023,
        name: 'Хирург',
        price: '100',
        is_active: true,
        deleted: false,
        code: '050001',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3021,
        name: 'Тестовая',
        price: '500',
        is_active: false,
        deleted: false,
        code: '100',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 14,
            resource_service: 3021,
            warehouse_item: 14,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '100 Тестовая',
            warehouse_item_view: 'Тест МДПЛ3 шт',
            is_vaccine: false,
            for_sale: true,
            sale_price: '400',
            warehouse_item_id: 14,
            name: 'Тест МДПЛ3',
            cost_value: 0,
            batch: {
              id: 79,
              warehouse: 3,
              warehouse_name: 'Запасной',
              series: null,
              expire_date: '',
              remains: 165,
            },
            batchs: [
              {
                id: 56,
                warehouse: 2,
                warehouse_name: 'Основной',
                series: '33',
                expire_date: '',
                remains: 5,
              },
              {
                id: 79,
                warehouse: 3,
                warehouse_name: 'Запасной',
                series: null,
                expire_date: '',
                remains: 165,
              },
            ],
          },
        ],
        type_view: 'Комплекс',
        global_resource_service_view: 'терапия',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
    ],
  },
  {
    id: 3037,
    name: 'Комплекс1',
    price: '100',
    is_active: true,
    deleted: false,
    code: '005',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3038,
    name: 'Комплекс1',
    price: '100',
    is_active: true,
    deleted: false,
    code: '005',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3039,
    name: 'Комплекс1',
    price: '100',
    is_active: true,
    deleted: false,
    code: '005',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [
      {
        id: 9,
        resource_service: 3039,
        warehouse_item: 9,
        quantity: 0,
        price_in_service: null,
        resource_service_view: '005 Комплекс1',
        warehouse_item_view: 'Тестовая вакцина шт',
        is_vaccine: true,
        for_sale: false,
        sale_price: '300',
        warehouse_item_id: 9,
        name: 'Тестовая вакцина',
        cost_value: 30,
        batch: {
          id: 81,
          warehouse: 2,
          warehouse_name: 'Основной',
          series: null,
          expire_date: '20.10.2025',
          remains: 10,
        },
        batchs: [
          {
            id: 75,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 1,
          },
          {
            id: 76,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 50,
          },
          {
            id: 83,
            warehouse: 9,
            warehouse_name: 'warehouse',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 42,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: '0000001',
            expire_date: '18.01.2025',
            remains: 14,
          },
          {
            id: 81,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '20.10.2025',
            remains: 10,
          },
        ],
      },
    ],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [
      {
        id: 3022,
        name: 'Тестовая 2',
        price: '400',
        is_active: true,
        deleted: false,
        code: '002',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 17,
            resource_service: 3022,
            warehouse_item: 17,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '002 Тестовая 2',
            warehouse_item_view: 'Еще материал 2 шт',
            is_vaccine: false,
            for_sale: false,
            sale_price: '500',
            warehouse_item_id: 17,
            name: 'Еще материал 2',
            cost_value: 237,
            batch: null,
            batchs: [],
          },
        ],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3023,
        name: 'Хирург',
        price: '100',
        is_active: true,
        deleted: false,
        code: '050001',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3021,
        name: 'Тестовая',
        price: '500',
        is_active: false,
        deleted: false,
        code: '100',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 14,
            resource_service: 3021,
            warehouse_item: 14,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '100 Тестовая',
            warehouse_item_view: 'Тест МДПЛ3 шт',
            is_vaccine: false,
            for_sale: true,
            sale_price: '400',
            warehouse_item_id: 14,
            name: 'Тест МДПЛ3',
            cost_value: 0,
            batch: {
              id: 79,
              warehouse: 3,
              warehouse_name: 'Запасной',
              series: null,
              expire_date: '',
              remains: 165,
            },
            batchs: [
              {
                id: 56,
                warehouse: 2,
                warehouse_name: 'Основной',
                series: '33',
                expire_date: '',
                remains: 5,
              },
              {
                id: 79,
                warehouse: 3,
                warehouse_name: 'Запасной',
                series: null,
                expire_date: '',
                remains: 165,
              },
            ],
          },
        ],
        type_view: 'Комплекс',
        global_resource_service_view: 'терапия',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
    ],
  },
  {
    id: 3040,
    name: 'Осмотр для самбери',
    price: '100',
    is_active: true,
    deleted: false,
    code: '005',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [
      {
        id: 9,
        resource_service: 3040,
        warehouse_item: 9,
        quantity: 0,
        price_in_service: null,
        resource_service_view: '005 Осмотр для самбери',
        warehouse_item_view: 'Тестовая вакцина шт',
        is_vaccine: true,
        for_sale: false,
        sale_price: '300',
        warehouse_item_id: 9,
        name: 'Тестовая вакцина',
        cost_value: 30,
        batch: {
          id: 81,
          warehouse: 2,
          warehouse_name: 'Основной',
          series: null,
          expire_date: '20.10.2025',
          remains: 10,
        },
        batchs: [
          {
            id: 75,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 1,
          },
          {
            id: 76,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 50,
          },
          {
            id: 83,
            warehouse: 9,
            warehouse_name: 'warehouse',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 42,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: '0000001',
            expire_date: '18.01.2025',
            remains: 14,
          },
          {
            id: 81,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '20.10.2025',
            remains: 10,
          },
        ],
      },
    ],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [
      {
        id: 3022,
        name: 'Тестовая 2',
        price: '400',
        is_active: true,
        deleted: false,
        code: '002',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 17,
            resource_service: 3022,
            warehouse_item: 17,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '002 Тестовая 2',
            warehouse_item_view: 'Еще материал 2 шт',
            is_vaccine: false,
            for_sale: false,
            sale_price: '500',
            warehouse_item_id: 17,
            name: 'Еще материал 2',
            cost_value: 237,
            batch: null,
            batchs: [],
          },
        ],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3023,
        name: 'Хирург',
        price: '100',
        is_active: true,
        deleted: false,
        code: '050001',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [],
        type_view: 'Комплекс',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
      {
        id: 3021,
        name: 'Тестовая',
        price: '500',
        is_active: false,
        deleted: false,
        code: '100',
        type: 230,
        is_group: false,
        can_discount: true,
        is_laboratory: false,
        duration: null,
        help_text: null,
        resource_service_list: 13,
        child_services: [],
        warehouse_items: [
          {
            id: 14,
            resource_service: 3021,
            warehouse_item: 14,
            quantity: 1,
            price_in_service: null,
            resource_service_view: '100 Тестовая',
            warehouse_item_view: 'Тест МДПЛ3 шт',
            is_vaccine: false,
            for_sale: true,
            sale_price: '400',
            warehouse_item_id: 14,
            name: 'Тест МДПЛ3',
            cost_value: 0,
            batch: {
              id: 79,
              warehouse: 3,
              warehouse_name: 'Запасной',
              series: null,
              expire_date: '',
              remains: 165,
            },
            batchs: [
              {
                id: 56,
                warehouse: 2,
                warehouse_name: 'Основной',
                series: '33',
                expire_date: '',
                remains: 5,
              },
              {
                id: 79,
                warehouse: 3,
                warehouse_name: 'Запасной',
                series: null,
                expire_date: '',
                remains: 165,
              },
            ],
          },
        ],
        type_view: 'Комплекс',
        global_resource_service_view: 'терапия',
        resource_service_list_view: 'Основной ',
        is_main_resource_service_list: true,
        duration_label: '',
        quantity: 1,
      },
    ],
  },
  {
    id: 3029,
    name: 'Еще одна',
    price: '1200',
    is_active: true,
    deleted: false,
    code: '009',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: 45,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [
      {
        id: 17,
        resource_service: 3029,
        warehouse_item: 17,
        quantity: 11,
        price_in_service: null,
        resource_service_view: '009 Еще одна',
        warehouse_item_view: 'Еще материал 2 шт',
        is_vaccine: false,
        for_sale: false,
        sale_price: '500',
        warehouse_item_id: 17,
        name: 'Еще материал 2',
        cost_value: 237,
        batch: null,
        batchs: [],
      },
      {
        id: 9,
        resource_service: 3029,
        warehouse_item: 9,
        quantity: 2,
        price_in_service: null,
        resource_service_view: '009 Еще одна',
        warehouse_item_view: 'Тестовая вакцина шт',
        is_vaccine: true,
        for_sale: false,
        sale_price: '300',
        warehouse_item_id: 9,
        name: 'Тестовая вакцина',
        cost_value: 30,
        batch: {
          id: 81,
          warehouse: 2,
          warehouse_name: 'Основной',
          series: null,
          expire_date: '20.10.2025',
          remains: 10,
        },
        batchs: [
          {
            id: 75,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 1,
          },
          {
            id: 76,
            warehouse: 3,
            warehouse_name: 'Запасной',
            series: null,
            expire_date: '',
            remains: 50,
          },
          {
            id: 83,
            warehouse: 9,
            warehouse_name: 'warehouse',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 42,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: '0000001',
            expire_date: '18.01.2025',
            remains: 14,
          },
          {
            id: 81,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '20.10.2025',
            remains: 10,
          },
        ],
      },
      {
        id: 12,
        resource_service: 3029,
        warehouse_item: 12,
        quantity: 5,
        price_in_service: null,
        resource_service_view: '009 Еще одна',
        warehouse_item_view: 'Вакцина2_МДЛП шт',
        is_vaccine: true,
        for_sale: false,
        sale_price: '211',
        warehouse_item_id: 12,
        name: 'Вакцина2_МДЛП',
        cost_value: 60,
        batch: {
          id: 48,
          warehouse: 2,
          warehouse_name: 'Основной',
          series: null,
          expire_date: '',
          remains: 5,
        },
        batchs: [
          {
            id: 44,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 3,
          },
          {
            id: 71,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 1,
          },
          {
            id: 70,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 69,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 68,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 67,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 66,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 65,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 64,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 63,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 55,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 53,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: 'wwww',
            expire_date: '',
            remains: 5,
          },
          {
            id: 51,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 50,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 49,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 48,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: null,
            expire_date: '',
            remains: 5,
          },
          {
            id: 47,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: '333',
            expire_date: '',
            remains: 3,
          },
          {
            id: 73,
            warehouse: 2,
            warehouse_name: 'Основной',
            series: '0',
            expire_date: '',
            remains: 2,
          },
        ],
      },
    ],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3023,
    name: 'Хирург',
    price: '100',
    is_active: true,
    deleted: false,
    code: '050001',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3032,
    name: '111',
    price: '344',
    is_active: true,
    deleted: false,
    code: '11',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3025,
    name: '33',
    price: '500',
    is_active: true,
    deleted: false,
    code: '22',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3026,
    name: '33',
    price: '500',
    is_active: true,
    deleted: false,
    code: '22',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3027,
    name: 'wer',
    price: '100',
    is_active: true,
    deleted: false,
    code: 'er',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
  {
    id: 3028,
    name: 'qwe',
    price: '1200',
    is_active: true,
    deleted: false,
    code: 'qwe',
    type: 230,
    is_group: false,
    can_discount: true,
    is_laboratory: false,
    duration: null,
    help_text: null,
    resource_service_list: 13,
    warehouse_items: [],
    type_view: 'Комплекс',
    resource_service_list_view: 'Основной ',
    is_main_resource_service_list: true,
    duration_label: '',
    child_services: [],
  },
].map((el) => {
  return {
    ...el,
    price: +el.price,
    quantity: 1,
  };
});

export const services =
  [
    {
      "id": 3197,
      "name": "ГЭ01.1 Консультация стандартная гастроэнтеролога",
      "price": "500",
      "code": "1997",
      "type": 235,
    },
    {
      "id": 66,
      "name": "ГЭ01.2 Консультация повторная гастроэнтеролога",
      "price": "800",
      "code": "2000",
      "type": 235,
    },
    {
      "id": 97,
      "name": "ГЭ01.3 Консультация расширенная гастроэнтеролога",
      "price": "1200",
      "code": "2001",
      "type": 235,
    },

      {
        "id": 47,
        "name": "КА01.01 Консультация стандартная кардиолога",
        "price": "1500",
        "code": "2037",
        "type": 240,
      },
      {
        "id": 55,
        "name": "КА01.01-1 ЭКГ",
        "price": "1000",
        "code": "2038",
        "type": 240,
      },
      {
        "id": 28,
        "name": "КСУ-123 Массаж спины",
        "price": "1000",
        "code": "2038",
        "type": 247,
      },
    {
      "id": 456,
      "name": "A-6 Пролактин",
      "price": "1000",
      "code": "2038",
      "type": 243,
    },
    {
      "id": 231,
      "name": "AS-43 Инсулин",
      "price": "1000",
      "code": "2038",
      "type": 243,
    },
]
